module.exports = __webpack_public_path__ + "img/logo_muic.d8337c27.png";